// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"gQ-z","carouselContainer":"hQ-z"};